import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewDetail: {
		id: 'aais-dependency-lines-overlay.common.line.view-detail',
		defaultMessage: 'View dependency detail',
		description: 'Tooltip text. Appears on the dependencies icon on the epic bar, when hovering.',
	},
});
